'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _playlist = require('redux/modules/playlist');

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _formComponents = require('components/formComponents');

var _components = require('components');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./FeedbackForm.scss');

var FeedbackForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sendFeedbackLoaded: state.playlist.sendFeedbackLoaded,
    sendFeedbackActionData: state.playlist.sendFeedbackActionData
  };
}, { sendFeedback: _playlist.sendFeedback }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'feedbackForm',
  propNamespace: 'feedbackForm',
  initialValues: { feedbackText: '' }
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(FeedbackForm, _Component);

  function FeedbackForm() {
    (0, _classCallCheck3.default)(this, FeedbackForm);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(FeedbackForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeedbackForm, [{
    key: 'sendFeedback',
    value: function sendFeedback(formData) {
      var _props = this.props,
          contentKey = _props.contentKey,
          reset = _props.feedbackForm.reset;


      var promise = this.props.sendFeedback({ key: contentKey, feedbackText: formData.feedbackText }).promise;
      promise.then(function () {
        reset();
      });

      return promise;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          t = _props2.t,
          sendFeedbackLoaded = _props2.sendFeedbackLoaded,
          sendFeedbackActionData = _props2.sendFeedbackActionData,
          contentKey = _props2.contentKey,
          sender = _props2.sender,
          compact = _props2.compact,
          buttons = _props2.buttons,
          line = _props2.line,
          _props2$feedbackForm = _props2.feedbackForm,
          handleSubmit = _props2$feedbackForm.handleSubmit,
          submitting = _props2$feedbackForm.submitting,
          invalid = _props2$feedbackForm.invalid;


      return sendFeedbackLoaded && sendFeedbackActionData.key === contentKey ? _react2.default.createElement(
        'div',
        { className: 'colorInfo h4' },
        _react2.default.createElement('i', { className: 'icon-check margin-right-5' }),
        t('Thank you. Your feedback has been transmitted.')
      ) : _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('row', (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.compact, compact), (0, _defineProperty3.default)(_classNames, styles.line, line), _classNames)) },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)({ 'col-sm-15 col-md-20 col-lg-20': !compact }, styles.feedbackHeader) },
          _react2.default.createElement(
            'h4',
            { className: 'margin-top-20' },
            t('Contact {{username}}', { username: sender }),
            ':'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)({ 'col-sm-45 col-md-40 col-lg-40': !compact }) },
          _react2.default.createElement(
            'form',
            { className: styles.form, onSubmit: handleSubmit(this.sendFeedback) },
            _react2.default.createElement(
              'div',
              { className: styles.textArea },
              _react2.default.createElement(_reduxForm.Field, {
                name: 'feedbackText',
                type: 'textarea',
                rows: '4',
                fieldClassName: 'width-perc-100',
                placeholder: t('Type your feedback here'),
                hideLabel: true,
                component: _formComponents.formSimpleTextInput,
                required: true
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.buttons },
              buttons,
              submitting ? _react2.default.createElement(_components.Loader, null) : _react2.default.createElement(
                'button',
                { type: 'submit', className: 'btn btn-default', disabled: submitting || invalid },
                t('Send')
              )
            )
          )
        )
      );
    }
  }]);
  return FeedbackForm;
}(_react.Component), _class3.propTypes = {
  buttons: _propTypes2.default.node,
  compact: _propTypes2.default.bool,
  contentKey: _propTypes2.default.string,
  feedbackForm: _propTypes2.default.object,
  line: _propTypes2.default.bool,
  sender: _propTypes2.default.string.isRequired,
  sendFeedback: _propTypes2.default.func,
  sendFeedbackActionData: _propTypes2.default.object,
  sendFeedbackLoaded: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'sendFeedback', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'sendFeedback'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = FeedbackForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/FeedbackForm/FeedbackForm.js
// module id = 829
// module chunks = 1